export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'fa fa-bar-chart-o',
    },
    {
      title: true,
      name: 'Pilgrimage',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'হজ্জযাত্রী নিবন্ধন',
      url: '/pilgrimage/registration/:pilgrim',
      icon: 'fa fa-user-plus'
    },
    {
      name: 'নিবন্ধসমূহের ব্যবস্থাপনা',
      url: '/pilgrimage/manage',
      icon: 'fa fa-users'
    },
    {
      name: 'রশিদ',
      url: '/pilgrimage/invoice/:pay',
      icon: 'fa fa-file-text'
    },
    {
      name: 'পূর্ববর্তী রশিদসমূহ',
      url: '/invoice/manage',
      icon: 'fa fa-files-o'
    },
    {
      name: 'পূর্ববর্তী নিবন্ধন',
      url: '/pilgrimage/oldRegistrations',
      icon: 'fa fa-file-pdf-o'
    },
    {
      divider: true
    }
  ]
}
